/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   dbo.ProfileActivityType_
///   This is an auto-generated enumeration of the SWFC_Learning.dbo.ProfileActivityType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum ProfileActivityType_ {
   /// <summary>
   ///   Quiz Started (QStart)
   /// </summary>
   QuizStarted = 1,
   /// <summary>
   ///   Quiz Completed (Aggregate value is Best Score) (QCompl)
   /// </summary>
   QuizCompleted = 2
}

export const ProfileActivityTypes: ProfileActivityType[] = [
   {
      code: ProfileActivityType_.QuizStarted,
      literal: 'QuizStarted',
      description: 'Quiz Started',
      shortDescription: 'QStart',
      listPriority: 0,

      typeName: "ProfileActivityType"
   },
   {
      code: ProfileActivityType_.QuizCompleted,
      literal: 'QuizCompleted',
      description: 'Quiz Completed (Aggregate value is Best Score)',
      shortDescription: 'QCompl',
      listPriority: 0,

      typeName: "ProfileActivityType"
   }
]

export class ProfileActivityType implements IDomainModel {
   code: ProfileActivityType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: ProfileActivityType_): ProfileActivityType {
      return ProfileActivityTypes.find(d => d.code === code)
   }
}
